<rt-dropdown [width]="DropdownWidth.FullWidth">
  <div class="content">
    <rt-button size="small" class="link-tooltip--button" variant="plain" (click)="edit.next()">
      {{ 'wysiwyg.edit_link' | translate }}
    </rt-button>
    <div class="separator"></div>
    <rt-icon-button
      size="small"
      iconName="open-in-new"
      shape="square"
      class="link-tooltip--button"
      variant="plain"
      (click)="open.next()"
    >
    </rt-icon-button>
    <rt-icon-button
      size="small"
      iconName="link-off"
      shape="square"
      class="link-tooltip--button"
      variant="plain"
      (click)="remove.next()"
    >
    </rt-icon-button>
  </div>
</rt-dropdown>
